import React, { useCallback, useEffect, useMemo, useState } from 'react'

import RBModal from 'react-bootstrap/Modal'
import { ModalProps } from './types'
type ModalState = 'exiting' | 'exited' | 'visible' | 'stuck' | 'hidden'
export const Modal = ({
  header,
  show,
  onHide,
  onShow,
  size = '',
  headerSubline,
  content,
  children,
  footer,
  id,
}: ModalProps): JSX.Element | null => {
  const [state, setState] = useState<ModalState>('hidden')
  useEffect(() => {
    if (show) setState((state) => (state !== 'exiting' && state !== 'visible' ? 'visible' : state))
    else setTimeout(() => setState((state) => (state === 'exited' || state === 'stuck' ? 'hidden' : state)), 100)
  }, [show])
  // console.log(state)

  const onExit = useCallback(() => {
    setState('exiting')
    setTimeout(() => {
      setState((state) => (state === 'exiting' ? 'stuck' : state))
    }, 1000)
  }, [])

  const onExited = useCallback(() => {
    setState((state) => (state === 'exiting' ? 'exited' : state))
  }, [])

  const display = useMemo(() => ['exiting', 'visible'].includes(state), [state])
  if (!display) return null
  return (
    <RBModal
      show={show}
      onShow={onShow}
      onExit={onExit}
      onExited={onExited}
      onHide={onHide}
      dialogClassName={size}
      id={id}
    >
      <RBModal.Header>
        <RBModal.Title>
          <p className="m-0">{header}</p>
          {headerSubline && <h5>{headerSubline}</h5>}
        </RBModal.Title>
        <button type="button" className="modal-close" aria-label="Close" onClick={onHide}></button>
      </RBModal.Header>

      <RBModal.Body>
        {content}
        {children}
      </RBModal.Body>

      {footer && <RBModal.Footer>{footer}</RBModal.Footer>}
    </RBModal>
  )
}
